import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { TokenService } from '../services/token-service';
import { IdentityService } from '../services/identity-service';
import { SignInResponse } from '../../shared/models/UserModels';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const tokenService = inject(TokenService);
  const identityService = inject(IdentityService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const refToken = tokenService.getRefreshToken();

        if (refToken) {
          // Refresh the token and retry the original request
          return identityService.refreshTokenSignIn(refToken).pipe(
            switchMap((res: SignInResponse) => {
              // Save new tokens
              tokenService.setTokens(res.access_token, res.refresh_token);

              // Clone and retry the original request with new token
              const clonedReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${res.access_token}`,
                },
              });
              return next(clonedReq);
            }),
            catchError((refreshError: HttpErrorResponse) => {
              // Refresh failed - redirect to sign in
              tokenService.removeTokens();
              router.navigate(['/sign-in']);
              return throwError(() => refreshError);
            }),
          );
        } else {
          // No refresh token available
          tokenService.removeTokens();
          router.navigate(['/sign-in']);
        }
      }

      return throwError(() => error);
    }),
  );
};
